<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    value?: number;
    labelClasses?: string;
    progressClasses?: string;
    progressContainerClasses?: string;
    theme?: ThemeColor;
    showLabel?: boolean;
  }>(),
  {
    value: 0,
    labelClasses: undefined,
    progressClasses: "progress-bar-default border-2 border-ngray-3 w-[100px] mx-10",
    progressContainerClasses: "flex flex-col items-center pb-2 ",
    theme: "primary",
    showLabel: true,
  },
);

const percentage = computed(() => props.value + "%");
const id = $ck.utils.getUID("progress");
</script>

<template>
  <div :class="[`theme-color-${theme}`, progressContainerClasses]">
    <div class="flex justify-between w-full pb-1">
      <slot v-if="$slots.labelText" name="labelText" />
      <label v-if="props.showLabel" :for="id" :class="labelClasses">{{ percentage }}</label>
    </div>

    <progress :id max="100" :value="value" :class="progressClasses">{{ percentage }}</progress>
  </div>
</template>

<style scoped lang="postcss">
.theme-color-primary {
  --color: var(--color-nblue-1);
  --background: var(--color-nblue-6);
}

.theme-color-secondary {
  --color: var(--color-nblue-1);
  --background: var(--color-nblue-3);
}
.progress-bar-default {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  border-radius: 10em;
  background: var(--background);
}
.progress-bar-default::-webkit-progress-bar {
  border-radius: 10em;
  background: var(--background);
}
.progress-bar-default::-webkit-progress-value {
  border-radius: 10em;
  background: var(--color);
}
</style>
